import { Collapse, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Link, useLocation } from 'react-router-dom'
import styles from './Menu.module.scss';
import EventRegister, { EVENT_SHOW_ALARM_LIST_POPUP, EVENT_SHOW_POPUP, EVENT_SHOW_POPUP_ALARM } from "utils/EventRegister";
import IconChevronDownV2 from "assets/icon/IconChevronDownV2";
import IconChevronUpV2 from "assets/icon/IconChevronUpV2";

const MenuItem = ({ item, isOpen, toggleContent, index }) => {
    const location = useLocation();
    
    useEffect(() => {
        // Check if the current location.pathname matches the provided URL then set open = true
        isActive(item.href) && handleClick();
    }, []);

    useEffect(() => {
        isChildActive() && handleClick();
    }, []);

    const isActive = (url) => {
        // Check if the current location.pathname matches the provided URL
        return location.pathname === url || location.pathname === `${url}/`;
    };

    const handleClick = () => {
        toggleContent(index);
    };

    const isChildActive = () => {
        // Check if the current location.pathname matches any of the child URLs
        return item.children?.find((route) => (
            isActive(route?.href) || route?.children?.find(_route => isActive(_route?.href))
        ));
    };
    
    const openNotify = () => {
        // EventRegister.emit(EVENT_SHOW_POPUP_ALARM);
        EventRegister.emit(EVENT_SHOW_POPUP, {
            open: true,
            type: EVENT_SHOW_ALARM_LIST_POPUP,
            payload: {
                showHeader: false,
                customStyle: {
                    backgroundColor: 'transparent'
                }
            }
        })
    }
    return (
        <>  
            {
                item?.isEnable && <React.Fragment>
                    {item?.code == "M003" ? <ListItemButton
                        onClick={openNotify}
                        className={`${styles['item-button']} ${isOpen && !isChildActive() ? styles['menu-selected'] : ''}`}
                    >
                        <ListItemText
                            primary={
                                <Typography
                                    className={styles['item-typography']}
                                >
                                    {item?.label}
                                </Typography>
                            }
                            sx={{
                            }}
                            className={styles['item-text']}
                        />
                        {item.children?.length !== 0 && (isOpen ? <IconChevronUpV2 /> : <IconChevronDownV2 />)}
                    </ListItemButton> : <ListItemButton
                        component={Link}
                        to={item.href != '' ? item?.href : '#'}
                        onClick={handleClick}
                        className={`${styles['item-button']} ${isOpen && !isChildActive() ? styles['menu-selected'] : ''}`}
                    >
                        <ListItemText
                            primary={
                                <Typography
                                    className={styles['item-typography']}
                                >
                                    {item?.label}
                                </Typography>
                            }
                            sx={{
                            }}
                            className={styles['item-text']}
                        />
                        {item.children?.length !== 0 && (isOpen ? <IconChevronUpV2 /> : <IconChevronDownV2 />)}
                    </ListItemButton>}
                    {item.children?.length !== 0 &&
                    <Collapse in={isOpen} timeout="auto">
                        <List className={styles['list-button-content']}>
                            {item.children?.map((route, index) => {
                                return <React.Fragment key={index}>
                                    {
                                        route?.isEnable && 
                                            <ListItemButton
                                                component={Link}
                                                to={route.href != '' ? route?.href : '#'}
                                                className={`${styles['item-button-content']} ${isActive(route.href) && isOpen && styles['menu-selected']}`}
                                                key={index}
                                            >
                                                <ListItemText
                                                    primary={
                                                        <Typography className={styles['item-typography-content']}>
                                                            {route.label}
                                                        </Typography>
                                                    }
                                                    className={styles['item-text-content']}
                                                />
                                                {route.children?.length !== 0 && (isOpen ? <IconChevronUpV2 /> : <IconChevronDownV2 />)}
                                            </ListItemButton>
                                    }
                                    {
                                        route?.children?.length > 0 && <Collapse in={isOpen} timeout="auto">
                                            <List className={styles['list-button-content']}>
                                                {route.children?.map((route3, index) => {
                                                    return route3.isEnable && <ListItemButton
                                                        component={Link}
                                                        to={route3.href != '' ? route3?.href : '#'}
                                                        className={`${styles['item-button-content']} ${isActive(route3.href) && isOpen && styles['menu-selected']}`}
                                                        key={index}
                                                    >
                                                        <ListItemText
                                                            primary={
                                                                <Typography
                                                                    className={styles['item-typography-content']}
                                                                >
                                                                    {route3?.label}
                                                                </Typography>
                                                            }
                                                            className={styles['item-text-content']}
                                                        />
                                                    </ListItemButton>
                                                })}
                                            </List>
                                        </Collapse>
                                    }
                                </React.Fragment>

                            })}
                        </List>
                    </Collapse>
                    }
                </React.Fragment>
            }
        </>
    );
};

export default MenuItem;